import { Component } from '@angular/core';

@Component({
  selector: 'muni-shared-component',
  template: '<router-outlet></router-outlet>'
})
export class SharedComponent {}
